<template>
    <div class="mainbody modulewrap" ref="mainbox">
        <div class="learnwrap" v-if="isload">
            <div class="learnmainwrap">
                <div class="learnmain" v-if="coursecurcontent.courseinfotypekv==101">
                    <myScroll class="scroll">
                        <div class="learnimg" v-for="(item,index) in coursecurcontent.x_imgs" :key="index">
                            <img :src="item" />
                        </div>
                    </myScroll>
                </div>
                <div class="learnmain" v-else-if="coursecurcontent.courseinfotypekv==102">
                    <div class="winmask" v-if="isshowmask"></div>
                    <div class="learnvideo" id="learnvideo"></div>
                </div>
                <div class="learnmain" v-else-if="coursecurcontent.courseinfotypekv==666">
                    <div class="learntest">
                        <div class="learntesttitle" v-html="$common.langinfo(coursecurcontent.title,coursecurcontent.title_en)"></div>
                        <div class="learntestcon">
                            <template v-if="examinfo.stat==0">
                                <div class="learntestdeswrap" v-if="coursecurcontent.x_paper">
                                    <myScroll class="scroll">
                                        <div class="learntestdes">
                                            {{$common.dicword('testminutes2',true)}}
                                            <template v-if="coursecurcontent.x_paper.examminutes">
                                                {{coursecurcontent.x_paper.examminutes}}{{$common.dicword('minutes')}}
                                            </template>
                                            <template v-else>
                                                {{$common.dicword('any')}}
                                            </template>
                                        </div>

                                        <div class="learntestdes">
                                            {{$common.dicword('totalscore',true)}}{{coursecurcontent.x_paper.paper.total}}
                                        </div>

                                        <div class="learntestdes2" v-for="(item,index) in coursecurcontent.x_paper.paper.questionsetting" :key="item.id">
                                            Part {{index + 1}}  -  {{item.title}}  <span>({{$common.dicword('questioncount',true)}}{{item.usc}}，{{$common.dicword('questionscore',true)}}{{item.score}})</span>
                                        </div>
                                        <div class="learntestdes2" v-if="coursecurcontent.x_paper.id && coursecurcontent.x_paper.stat==9">
                                            {{$common.dicword('score',true)}}{{coursecurcontent.x_paper.grade}}
                                        </div>
                                    </myScroll>
                                </div>
                            </template>
                            <template v-else>
                                <div class="learntestsidewrap">
                                    <myScroll class="scroll">
                                        <div class="learntestside">
                                            <div v-if="examinfo.stat<=2" class="progressbar">
                                                <div class="title"><span class="a">{{$common.dicword('answerprogress')}}</span><span class="b">{{qcount}}/{{qmax}}</span></div>
                                                <div class="bar">
                                                    <div class="cur"><span class="line" :style="{width:qprogress+'%'}"></span><span class="circle"></span></div>
                                                </div>
                                                <div class="tip">{{$common.dicword('totalscore',true)}}{{testdata.gradetotal}}</div>
                                            </div>
                                            <div v-else class="progressbar">
                                                <div class="title" v-if="$store.getters.isstu"><span class="a">{{$common.dicword('score',true)}}</span><span class="b">{{testdata.grade}}/{{testdata.gradetotal}}</span></div>
                                                <div class="title" v-else><span class="a">{{$common.dicword('totalscore',true)}}</span><span class="b">{{testdata.gradetotal}}</span></div>
                                            </div>
                                            <dl class="answertype">
                                                <dd v-if="examinfo.stat>2"><span class="right"></span>{{$common.dicword('statright')}}</dd>
                                                <dd v-if="examinfo.stat>2"><span class="error"></span>{{$common.dicword('staterror')}}</dd>
                                                <dd v-if="examinfo.stat<=2"><span class="done"></span>{{$common.dicword('statdone')}}</dd>
                                                <dd v-if="examinfo.stat<=2"><span class="ready"></span>{{$common.dicword('statready')}}</dd>
                                            </dl>
                                            <div class="answersheet">
                                                <myScroll class="scroll">
                                                    <div class="aspart" v-for="(item,index) in testdata.paper" :key="index">
                                                        <div class="qtype"><span>{{(index+1)}}</span> {{item.title}}</div>
                                                        <dl>
                                                            <dd v-for="(item2,index2) in item.questionlist" :key="index2" :class="choicestat(index,index2)" @click="questiongo(index,index2)"></dd>
                                                        </dl>
                                                    </div>
                                                </myScroll>
                                            </div>
                                        </div>
                                    </myScroll>
                                </div>

                                <div class="learntestinfo">

                                    <div class="qpart">
                                        Part {{examinfo.partindex + 1}}  -  {{partcur.title}}  <span>({{$common.dicword('questioncount',true)}}{{partcur.usc}}，{{$common.dicword('questionscore',true)}}{{partcur.score}})</span>
                                    </div>

                                    <myScroll class="scroll" v-if="isquestionchange">
                                        <dl class="qstem">
                                            <dt>{{(examinfo.qindex+1)}}.</dt>
                                            <dd class="editor"><span v-html="$common.basic.ffinputline(questioncur.constem)"></span></dd>
                                        </dl>
                                        <template v-if="partcur.qtkv==1">
                                            <label v-for="(item,index) in questioncur.x_conoptions" :key="item.id">
                                                <dl class="choice">
                                                    <dt>
                                                        <template v-if="examinfo.stat<=2">
                                                            <input type="radio" @change="questionchoose" name="Ra" v-model="answercur.selectoption" :value="item.id" />
                                                        </template>
                                                        <template v-else>
                                                            <span :class="answerstat(examinfo.partindex,examinfo.qindex,(index+1))"></span>
                                                        </template>
                                                        {{$common.basic.chint2letter(index)}}.
                                                    </dt>
                                                    <dd v-html="item.conoption"></dd>
                                                </dl>
                                            </label>
                                        </template>
                                        <template v-else-if="partcur.qtkv==4">
                                            <el-radio-group v-model="answercur.selectoption">
                                                <el-radio label="1">True</el-radio>
                                                <el-radio label="2">False</el-radio>
                                                <el-radio label="3">NOT GIVEN</el-radio>
                                            </el-radio-group>
                                        </template>

                                        <div class="testanswerarea" v-else-if="partcur.qtkv==5||partcur.qtkv==6">
                                            <template v-if="examinfo.stat<=2">
                                                <el-input type="textarea"
                                                          :rows="10"
                                                          v-model="answercur.selectoption">
                                                </el-input>
                                                <div class="examattach">
                                                    <ffuploadimgs :value.sync="answercur.attach"></ffuploadimgs>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="testmyanswerwrap">
                                                    <div class="testmyanswer" v-html="getanswer(examinfo.partindex,examinfo.qindex).selectoption"></div>
                                                    <div class="examattach">
                                                        <ffuploadimgs :value.sync="getanswer(examinfo.partindex,examinfo.qindex).attach" :isupload="false"></ffuploadimgs>
                                                    </div>
                                                    <div v-if="testdata.isjudge" class="testmarkgrade">
                                                        {{$common.dicword('score',true)}}{{getanswer(examinfo.partindex,examinfo.qindex).score}}
                                                    </div>
                                                    <div v-if="testdata.isjudge && getanswer(examinfo.partindex,examinfo.qindex).rightoption" class="testmark editor"><span v-html="getanswer(examinfo.partindex,examinfo.qindex).rightoption"></span></div>
                                                </div>


                                            </template>
                                        </div>

                                        <dl class="qstemsub" v-if="(!$store.getters.isstu||examinfo.stat==9) && answeranalysis(examinfo.partindex,examinfo.qindex)">
                                            <dt>{{$common.dicword('analysis',true)}}</dt>
                                            <dd class="editor"><span v-html="answeranalysis(examinfo.partindex,examinfo.qindex)"></span></dd>
                                        </dl>
                                    </myScroll>
                                </div>
                            </template>
                        </div>
                        <div class="learntestbtn">
                            <div class="learntestbtnhastime">
                                <div class="learntestremain">
                                    <template v-if="!examinfo.isnotime && istesting">
                                        <template v-if="!$store.getters.issmall">
                                            <i class="iconfont icon-naozhong"></i>
                                            {{$common.dicword('remaintime',true)}}
                                        </template>
                                        {{$common.basic.chint2timewithsecond(examinfo.remainseconds)}}
                                    </template>

                                </div>
                                <div class="learntestbtnlink">
                                    <a v-if="(!$store.getters.isstu||(coursecurcontent.x_perc==100)) && examinfo.stat==0" href="#" @click="testbegin">{{$common.dicword('examview')}}</a>
                                    <a href="#" v-else-if="examinfo.stat==0 && !islearning">{{$common.dicword('waitschedule')}}</a>
                                    <a v-else-if="examinfo.stat==0" href="#" @click="testbegin">{{$common.dicword('examstart')}}</a>

                                    <template v-else>
                                        <a href="#" :class="{'disable':isbegin}" @click="questionprev">{{$common.dicword('examprev')}}</a>
                                        <a href="#" :class="{'disable':isend}" @click="questionnext">{{$common.dicword('examnext')}}</a>
                                    </template>

                                    <a href="#" v-if="istesting" @click="testsubmit()" :class="[{'disable':qcount!=qmax}]">{{$common.dicword('submit')}}</a>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>
            </div>
            <div :class="['learnside',$store.getters.issmall?'':issidefirst?'transiderightdefault':isshowside?'transiderightback':'transideright']">
                <div class="learnsidebtn">
                    <ul>
                        <li><a href="#" :class="{cs:infoindex==1}" @click="infoindex=1"><i class="iconfont icon-menu"><span>{{$common.dicword('course')}}</span></i></a></li>
                        <li><a href="#" :class="{cs:infoindex==2}" @click="infoindex=2"><i class="iconfont icon-wodezuoye"><span>{{$common.dicword('note')}}</span></i></a></li>
                        <li><a href="#" @click="goprev()"><i class="iconfont icon-arrow-up-bold"><span>{{$common.dicword('prevcourse')}}</span></i></a></li>
                        <li><a href="#" @click="gonext()"><i class="iconfont icon-arrow-down-bold"><span>{{$common.dicword('nextcourse')}}</span></i></a></li>

                        <li v-if="!$store.getters.issmall"><a href="#" class="b" @click="showside"><i :class="['iconfont',' icon-fanye1',issidefirst?'': isshowside ? 'transitionrotateback':'transitionrotate']"></i></a></li>

                    </ul>
                </div>
                <div class="learnsideinfo">
                    <div class="learncourseinfo">
                        <div class="cover">
                            <img :src="coursetree.cover" />
                        </div>
                        <dl class="info">
                            <dt>{{$common.langinfo(leveldata.title,leveldata.title_en)}}</dt>
                            <dd class="a">{{$common.langinfo(coursetree.title,coursetree.title_en)}}</dd>
                            <dd class="b">{{$common.dicword('expirydate',true)}}{{$common.basic.dateformat(infodataexpire.datebegin)}}/{{$common.basic.dateformat(infodataexpire.dateend)}}</dd>
                            <dd class="c">{{$common.dicword('totaltime',true)}}{{$common.basic.chint2timewithsecond(coursetree.x_duration)}}<span class="myspace"></span>{{$common.dicword('coursewares',true)}}{{courselearned}}/{{coursetree.x_count}}</dd>
                        </dl>
                    </div>
                    <div class="learncon" v-show="infoindex==1">
                        <myScroll class="scroll">
                            <div class="list" v-for="item in coursetree.x_children" :key="item.id">
                                <dl :title="$common.langinfo( item.title,item.title_en)" @click="showdetail(item.id)">
                                    <dt><ffoverdot :title="item.title" :title_en="item.title_en" :needtitle="false"></ffoverdot></dt>
                                    <dd class="open"><i class="iconfont icon-zhankai" :style="{transform: 'rotate('+(item.x_isopen?'180':'0')+'deg)'}"></i></dd>
                                </dl>
                                <Ccoursetree v-if="item.courseinfotypekv==1" :courseinfo="item" :curid="curid" @showdetail="showdetail" :firstid="coursefirstid"></Ccoursetree>
                            </div>
                        </myScroll>
                    </div>
                    <div class="learncon" v-show="infoindex==2">
                        <myScroll class="scroll" ref="myscroll">
                            <div class="learnnote">
                                <div class="learnnoteform">
                                    <div class="learnnotetime">
                                        <span class="a" v-if="coursecurcontent.courseinfotypekv==102">{{$common.basic.chint2timewithsecond(noteinfo.duration)}}</span><span class="b">
                                            <template v-if="noteinfo.recorddate">
                                                {{$common.basic.dateformat(noteinfo.recorddate,'yyyy-MM-dd hh:mm:ss')}}
                                            </template>
                                        </span>
                                    </div>
                                    <div class="learnnoteinput">
                                        <el-input type="textarea"
                                                  :rows="5"
                                                  v-model="noteinfo.content">
                                        </el-input>
                                    </div>
                                    <div class="learnnotebtn">
                                        <a href="#" v-if="noteinfo.id>0" @click="notenew()">{{$common.dicword('newnote')}}</a>
                                        <a href="#" class="btnsave" @click="notesave()">{{$common.dicword('save')}}</a>
                                    </div>
                                </div>
                                <div class="learnnotelist" v-if="$common.basic.isarrayexist(notelistcur)">
                                    <dl v-for="item in notelistcur" :key="item.id">
                                        <dt @click="noteshow(item.id)"><span v-html="item.content"></span></dt>
                                        <dd class="learnnotetime">
                                            <span class="a">
                                                <template v-if="coursecurcontent.courseinfotypekv==102">
                                                    {{$common.basic.chint2timewithsecond(item.duration)}}
                                                </template>
                                            </span><span class="b">
                                                <template v-if="item.recorddate">
                                                    {{$common.basic.dateformat(item.recorddate,'yyyy-MM-dd hh:mm:ss')}}
                                                </template>
                                            </span>
                                        </dd>
                                        <dd class="learnotedel"><a href="#" @click="notedel(item.id)">{{$common.dicword('del')}}</a></dd>
                                    </dl>

                                </div>
                                <div class="learnnotemorewrap" v-if="$common.basic.isarrayexist(notelistother)">
                                    <div class="learnnotemore">
                                        <dl v-for="item in notelistother" :key="item.id" v-if="item.x_topictitle">
                                            <dd class="learnnotetopic">{{item.x_topictitle}}</dd>
                                            <dt @click="noteshow(item.id)"><span v-html="item.content"></span></dt>
                                            <dd class="learnnotetime">
                                                <span class="a">
                                                    <template v-if="item.duration">
                                                        {{$common.basic.chint2timewithsecond(item.duration)}}
                                                    </template>
                                                </span><span class="b">
                                                    <template v-if="item.recorddate">
                                                        {{$common.basic.dateformat(item.recorddate,'yyyy-MM-dd hh:mm:ss')}}
                                                    </template>
                                                </span>
                                            </dd>
                                            <dd class="learnotedel"><a href="#" @click="notedel(item.id)">{{$common.dicword('del')}}</a></dd>
                                        </dl>

                                    </div>
                                </div>
                            </div>
                        </myScroll>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Cookie from 'vue-cookies';

    export default {
        name: 'learn',
        components: {
            Ccoursetree: () => import('@/components/Ccoursetree')
        },
        data() {
            return {
                sourcecourse: {},//来源课程
                isload: false,
                openids: [],
                isshowmask: true,
                videocurtime: 0,
                infoindex: 1,
                issidefirst: true,
                isshowside: true,
                mlev: 0,
                learnid: 0,

                infodataexpire: {},

                courseinfo: {},//课程信息，如果是链接课程，title是链接课程的
                coursedata: [],
                leveldata: {},
                curid: 0,
                curcontentid: 0,//当前内容id


                myinterval: '',

                examinfodefault: {
                    id: 0,
                    topicid: 0,
                    courseid: 0,
                    stat: 0,
                    remainseconds: 0,
                    isnotime: false,
                    qindex: 0,
                    partindex: 0,
                    answersheet: []
                },
                examinfo: {},
                isquestionchange: true,//用于刷新试题
                testdata: {},
                remaininterval: '',
                notelist: [],
                noteinfo: {
                    duration: 0,
                    content: '',
                    topicid: 0,
                    id: 0,
                    recorddate: ''
                },
                islearning: false,
                savetimeout: '',
                isneedsave: false,//是否需要保存
                xindex: 0//用于tree排序的公共变量
            }
        },
        computed: {
            smalllearninfo: function () {
                if (this.$store.getters.issmall) {
                    return { 'height': this.infoheight + 'px' };
                }
                else {
                    return {};
                }
            },
            courselist: function () {
                let _courselist = [];
                if (this.$common.basic.isarrayexist(this.coursedata)) {
                    _courselist = this.setcoursedata(this.coursedata);
                }

                return _courselist;
            },
            coursetree: function () {
                return this.courselist[0];
            },
            coursecur: function () {
                return this.$common.basic.fffind(this.coursedata, 'id', this.curid);
            },
            coursecurcontent: function () {
                return this.$common.basic.fffind(this.coursedata, 'id', this.curcontentid);
            },
            courseparent: function () {
                return this.$common.basic.fffind(this.coursedata, 'id', this.coursecur.pid);
            },
            coursefirstid: function () {
                return this.getfirstcourse(0);
            },
            courselearned: function () {
                let _courselearned = 0;

                this.$common.each(this.coursedata, item => {
                    if (item.x_perc >= 100) {
                        _courselearned++;
                    }
                })

                return _courselearned;
            },
            cookiename: function () {
                return 'examinfo_' + this.coursetree.id;
            },
            qcount: function () {
                let answerd = this.examinfo.answersheet.filter(item => item.selectoption) || [];
                return answerd.length;
            },
            qmax: function () {
                return this.examinfo.answersheet.length;
            },
            qprogress: function () {
                return this.qmax == 0 ? 0 : Math.round(this.qcount * 100 / this.qmax)
            },
            partcur: function () {
                return this.testdata.paper ? this.testdata.paper[this.examinfo.partindex] || {} : {};
            },
            questioncur: function () {
                return this.partcur.questionlist ? this.partcur.questionlist[this.examinfo.qindex] || {} : {};
            },
            answercur: function () {
                return this.$common.basic.fffind(this.examinfo.answersheet, 'id', this.questioncur.id);
            },
            modifyfirst: function () {
                return [0, 0];
            },
            modifylast: function () {
                return this.testdata.paper ? [this.testdata.paper.length - 1, this.testdata.paper[this.testdata.paper.length - 1].questionlist.length - 1] : [0, 0];
            },
            isbegin: function () {
                return (this.examinfo.partindex == this.modifyfirst[0]) && (this.examinfo.qindex == this.modifyfirst[1]);
            },
            isend: function () {
                return (this.examinfo.partindex == this.modifylast[0]) && (this.examinfo.qindex == this.modifylast[1]);
            },

            istesting: function () {
                return this.$store.getters.isstu && this.examinfo.stat > 0 && this.examinfo.stat < 9 && (this.$common.basic.isarrayexist(this.coursedata) ? this.coursetree.id == this.examinfo.courseid : false);
            },
            notelistcur: function () {
                let _notelistcur = [];
                if (this.$common.basic.isarrayexist(this.notelist)) {
                    _notelistcur = this.$common.basic.fffilter(this.notelist, 'topicid', this.curcontentid);
                }
                return _notelistcur;
            },
            notelistother: function () {
                let _notelistother = [];
                if (this.$common.basic.isarrayexist(this.notelist)) {
                    _notelistother = this.notelist.filter(item => item.topicid != this.curcontentid);
                }
                return _notelistother;
            }
        },
        methods: {
            setcoursedata: function (listdata, lev = 0, pid = 0) {
                let treedata = [];
                if (this.$common.basic.isarrayexist(listdata)) {

                    treedata = listdata.filter(item => (item.lev == lev) && (item.pid == pid)) || [];
                    this.$common.each(treedata, item => {
                        item.x_index = this.xindex;
                        this.xindex++;
                        item.x_children = this.setcoursedata(listdata, lev + 1, item.id);
                    });
                }
                return treedata;
            },
            examinfoinit: function () {
                let _examinfo = Cookie.get(this.cookiename);
                if (this.$common.basic.chempty(_examinfo)) {
                    this.examinfo = this.$common.basic.jsonclone(this.examinfodefault);
                }
                else {
                    this.examinfo = _examinfo;
                }

            },
            datainit: function () {

                let subfn = this.$route.params.sub;
                let subid = this.$route.params.subid || 0;
                let id = this.$common.basic.chstr2int(this.$route.params.id);

                let jsondata = { 'postdata': { 'act': 'tc_learn_course', 'id': id, 'data': { 't': subfn, 'subid': subid } } };

                this.$common.post(jsondata, res => {
                    if (!res.infodata || res.infodata.id == 0) {
                        this.$common.alert('coursexpired');
                        this.$router.replace('/member');
                        return false;
                    }

                    if (res.infodatacourse.typekv != this.$common.CTVIDEO) {
                        let learnurl = '/course/';
                        if (subfn) {
                            learnurl += subfn + '/' + subid;
                        }
                        else {
                            learnurl += id + (subid ? '/' + subid : '');
                        }
                        this.$router.replace(learnurl);
                        return false;
                    }

                    let totalduration = 0;
                    let coursecount = 0;
                    this.$common.each(res.infodatatree, (item) => {
                        item.x_perc = 0;
                        item.x_learncount = 0;
                        let pro = this.$common.basic.fffind(res.infodataprogress, 'sourceid', item.id);

                        if (this.$common.basic.isobjexist(pro)) {

                            item.x_perc = Math.round(pro.perc);
                            item.x_learncount = pro.learncount;
                            item.x_duration = 0;
                        }
                        //item.x_iscomplete = item.x_perc == 100;
                        item.x_isload = false;
                        item.x_isopen = false;
                        item.x_children = [];
                        item.x_quizstat = 0;
                        item.x_durationlearn = 0;
                        item.x_paper = '';

                        if (item.courseinfotypekv > 1) {
                            coursecount++;
                            if (item.courseinfotypekv == 102) {
                                totalduration += item.duration
                            }
                        }

                        item.x_maxlearn = res.infodata.maxlearn;
                        switch (item.courseinfotypekv) {
                            case 101:
                                item.x_imgs = item.imgs ? item.imgs.split(',') : [];
                                break;
                        }
                    });

                    let _courseinfo = this.$common.basic.fffind(res.infodatatree, 'id', res.infodatacourse.id);//替换的coursetree里的course的相关信息

                    _courseinfo.title = res.infodata.title;
                    _courseinfo.title_en = res.infodata.title_en;
                    _courseinfo.cover = res.infodatacourse.cover;
                    _courseinfo.x_duration = totalduration;
                    _courseinfo.x_count = coursecount;

                    _courseinfo.x_isload = true;

                    /*this.$common.each(res.infodatatree, item => {//并入之前循环
                        item.x_maxlearn = res.infodata.maxlearn;
                        switch (item.courseinfotypekv) {
                            case 101:
                                item.x_imgs = item.imgs ? item.imgs.split(',') : [];
                                break;
                        }
                    });*/

                    this.$common.each(res.infodatanote, item => {
                        item.x_topictitle = '';
                        let itemcourse = this.$common.basic.fffind(res.infodatatree, 'id', item.topicid);

                        if (this.$common.basic.isobjexist(itemcourse)) {
                            item.x_topictitle = this.$common.langinfo(itemcourse.title, itemcourse.title_en);
                        }
                    });

                    this.sourcecourse = res.infodata;

                    this.xindex = 0;
                    if (this.$common.basic.isarrayexist(res.infodatatree)) {
                        this.setcoursedata(res.infodatatree);
                        res.infodatatree.sort((a, b) => a.x_index - b.x_index);//排序方便上下翻页
                    }
                    this.coursedata = res.infodatatree;
                    this.leveldata = res.infodatalevel;

                    this.infodataexpire = res.infodataexpire;
                    this.notelist = res.infodatanote;

                    this.islearning = res.islearning == 1;

                    subid = this.getfirstcourse(res.subid || 0);

                    this.showdetail(subid);

                    this.isload = true;
                });
            },
            getfirstcourse(id) {
                let citem = id == 0 ? this.coursetree : this.$common.basic.fffind(this.coursedata, 'id', id);
                if (citem.courseinfotypekv == 1) {
                    let children = this.$common.basic.fffilter(this.coursedata, 'pid', citem.id);
                    if (this.$common.basic.isarrayexist(children)) {
                        let cid = children[0].id;
                        return this.getfirstcourse(cid);
                    }
                    else {
                        return citem.id;
                    }
                }
                else {
                    return citem.id;
                }

            },
            goprev() {

                let prevlist = this.coursedata.filter(item => item.x_index < this.coursecurcontent.x_index && item.courseinfotypekv > 1);
                if (this.$common.basic.isarrayexist(prevlist)) {
                    this.showdetail(prevlist[prevlist.length - 1].id);
                }
            },
            gonext() {
                let nindex = this.coursedata.findIndex((item => item.x_index > this.coursecurcontent.x_index && item.courseinfotypekv > 1));
                if (nindex >= 0) {
                    this.showdetail(this.coursedata[nindex].id);
                }
            },
            courseopen(id) {
                this.curid = id;
                this.openids = [id];
                this.setopenids(id);
                this.$common.each(this.coursedata, item => {
                    if (this.openids.findIndex(item2 => item2 == item.id) >= 0) {
                        item.x_isopen = true;
                    }
                    else {
                        item.x_isopen = false;
                    }
                });
            },
            showdetail(id, noteid = 0) {
                this.examinfoinit();

                if (this.istesting) {
                    id = this.examinfo.topicid;
                }


                if (id == 0) {
                    id = this.coursefirstid;
                }

                if (id == 0) {
                    return;
                }
                if (id < 0) {
                    this.curid = this.coursetree.id;
                    this.$common.each(this.coursetree.x_children, item => {
                        item.x_isopen = false;
                    });
                    return;
                }
                if (this.curid == id) {
                    if (this.coursecur.courseinfotypekv == 1) {
                        this.coursecur.x_isopen = !this.coursecur.x_isopen;
                    }

                }
                else {
                    let gocourse = this.$common.basic.fffind(this.coursedata, 'id', id);
                    if (this.$common.basic.isobjexist(gocourse)) {
                        if (gocourse.courseinfotypekv == 1) {
                            this.courseopen(id);
                        }
                        else {
                            this.showcontent(id, noteid);
                        }
                    }

                }

            },
            showcontent(id, noteid = 0) {
                let jsondata = {
                    'postdata': {
                        'act': 'tc_learn_access', 'id': id, 'data': { 'sourceid': this.sourcecourse.id }
                    }
                };
                this.$common.post(jsondata, (res) => {
                    if (res.issortallow && res.ismaxallow) {
                        let gocourse = this.$common.basic.fffind(this.coursedata, 'id', id);
                        if (this.$common.basic.isobjexist(res.infodatalearn)) {
                            gocourse.x_duration = res.infodatalearn.duration;
                        }
                        this.showcontentinfo(id, noteid);
                    }
                    else {
                        this.$common.alert(this.$common.langinfo(res.infodata.title, res.infodata.title_en));
                    }
                });
            },
            showcontentinfo(id, noteid = 0) {
                this.curid = id;
                this.curcontentid = id;
                this.isshowmask = true;

                if (!this.courseparent.x_isopen) {
                    this.courseopen(id);
                }
                if (noteid) {
                    let notecur = this.$common.basic.fffind(this.notelist, 'id', noteid);
                    if (this.$common.basic.isobjexist(notecur)) {
                        this.noteinfo = this.$common.basic.jsonclone(notecur);
                        this.noteinfo.content = this.$common.basic.streditor2area(this.noteinfo.content);
                    }
                    else {
                        this.noteclear();
                    }
                }
                else {
                    this.noteclear();
                }

                this.learnsavewait();
                if (this.coursecurcontent.courseinfotypekv == 102) {
                    this.videocurtime = this.noteinfo.id ? this.noteinfo.duration : this.coursecurcontent.x_duration || 0;
                    this.initPolyv(this.loadPolyv);
                    this.coursecurcontent.x_learncount++;
                }
                else if (this.coursecurcontent.courseinfotypekv == 101) {
                    //this.learnprogress();
                    this.PolyvClear();
                    this.coursecurcontent.x_learncount++;
                }
                else if (this.coursecurcontent.courseinfotypekv == 666) {
                    this.PolyvClear();
                    this.testprepare();
                }
            },
            testfinish: function () {
                this.examinfo.stat = 9;//当前考试的状态

                this.examinfo.remainseconds = 0;
                if (!this.examinfo.isnotime) {
                    Cookie.remove(this.cookiename);
                }
                this.learnprogress(true);
                this.questiongo(0, 0);
            },
            testprepare: function () {
                if (this.istesting) {
                    this.testbegin();
                }
                else {
                    this.examinfo.stat = 0;
                    let jsondata = {
                        'postdata': { 'act': 'tc_learn_testprepare', 'id': this.curcontentid, 'data': { 'courseid': this.sourcecourse.id } }
                    };
                    this.$common.post(jsondata, (res) => {
                        if (this.$common.basic.isobjexist(res.infodata)) {
                            res.infodata.paper = JSON.parse(res.infodata.conpaperuse);
                            this.coursecurcontent.x_paper = res.infodata;
                        }

                    });
                }

            },
            testbegin: function () {

                let jsondata = {
                    'postdata': { 'act': 'tc_learn_test', 'id': this.curcontentid, 'data': { 'courseid': this.sourcecourse.id } }
                };
                this.$common.post(jsondata, (res) => {
                    if (!res.infodata) {
                        this.testfinish();
                        this.$common.alert('examnopaper');
                        return;
                    }
                    let paper = JSON.parse(res.infodata.conpaperuse);
                    res.infodata.paper = paper.questionsetting;
                    let _answersheet = [];
                    this.$common.each(res.infodata.paper, item => {
                        this.$common.each(item.questionlist, (item2) => {
                            item2.x_conoptions = item2.conoptions ? JSON.parse(item2.conoptions) : [];
                            _answersheet.push({ 'id': item2.id, 'selectoption': '' });
                        });
                    });

                    res.infodata.conreply = res.infodata.conreply ? JSON.parse(res.infodata.conreply) : [];
                    res.infodata.conanswer = res.infodata.conanswer ? JSON.parse(res.infodata.conanswer) : [];

                    this.testdata = res.infodata;


                    if (this.examinfo.stat == 0) {

                        this.examinfo.id = this.testdata.id;
                        this.examinfo.topicid = this.testdata.topicid;
                        this.examinfo.courseid = this.testdata.courseid;
                        this.examinfo.answersheet = _answersheet;
                        this.examinfo.remainseconds = this.testdata.examminutes * 60;
                        this.examinfo.isnotime = this.testdata.examminutes == 0;
                    }
                    this.examinfo.stat = this.testdata.stat;

                    this.saveexaminfo();

                    if (this.testdata.stat == 9) {
                        this.testfinish();
                    }
                    else {
                        if (this.$store.getters.isstu) {
                            this.examinfo.remainseconds = this.testdata.remainseconds;
                            if (!this.examinfo.isnotime && this.testdata.remainseconds <= 0) {
                                this.testpost();
                            }
                        }

                    }
                });
            },
            testpost: function () {
                if (this.$store.getters.isstu) {
                    let jsondata = {
                        'postdata': { 'act': 'tc_learn_testsubmit', 'id': this.examinfo.id, 'pid': this.sourcecourse.id, 'data': { 'answersheet': JSON.stringify(this.examinfo.answersheet) } }
                    };
                    this.$common.post(jsondata, (res) => {
                        this.testdata.grade = res.infodata.grade;
                        this.testdata.conreply = res.infodata.conreply ? JSON.parse(res.infodata.conreply) : [];
                        this.testdata.conanswer = res.infodata.conanswer ? JSON.parse(res.infodata.conanswer) : [];
                        this.testfinish();

                    });
                }
            },
            testsubmit: function () {
                if (this.qcount == this.qmax) {
                    this.$common.confirm("examconfirmsubmit", () => {
                        this.testpost();
                    });
                }
            },
            questiongo: function (p, q) {
                this.isquestionchange = false;
                this.$nextTick(() => {
                    if (this.examinfo.stat > 0) {
                        this.examinfo.partindex = p;
                        this.examinfo.qindex = q;
                        this.isquestionchange = true;
                    }
                })


            },
            questionchoose: function () {
                this.saveexaminfo();
                window.setTimeout(() => {
                    this.questionnext();
                }, 500);
            },
            questionnext: function () {
                let p = this.examinfo.partindex;
                let q = this.examinfo.qindex + 1;
                if (q >= this.testdata.paper[p].questionlist.length) {
                    if (p < this.testdata.paper.length - 1) {
                        p++;
                        q = 0;
                    }

                }

                if ((p >= this.modifylast[0]) && (q >= this.modifylast[1])) {
                    p = this.modifylast[0];
                    q = this.modifylast[1];
                }
                this.questiongo(p, q);

            },
            questionprev: function () {

                let q = this.examinfo.qindex - 1;
                let p = this.examinfo.partindex;
                if (q < 0) {
                    if (p > 0) {
                        p--;
                        q = this.testdata.paper[p].questionlist.length - 1;
                    }

                }

                if ((p <= this.modifyfirst[0]) && (q <= this.modifyfirst[1])) {
                    p = this.modifyfirst[0];
                    q = this.modifyfirst[1];
                }

                this.questiongo(p, q);

            },


            choicestat: function (p, q) {
                let _choicestat = 'ready';
                let cpart = this.testdata.paper[p];
                let questionid = cpart.questionlist[q].id;

                if (this.examinfo.stat <= 2) {
                    let answerchoose = this.$common.basic.fffind(this.examinfo.answersheet, 'id', questionid);
                    _choicestat = answerchoose.selectoption ? 'done' : 'ready';
                }
                if (this.examinfo.stat > 2) {
                    let answerchoose = this.$common.basic.fffind(this.testdata.conreply, 'id', questionid);

                    _choicestat = cpart.qtkv >= 5 ? "done" : answerchoose.score > 0 ? 'right' : 'error';
                }

                if (((p == this.examinfo.partindex) && (q == this.examinfo.qindex))) {
                    _choicestat += ' cs';
                }
                return _choicestat;
            },
            getanswer: function (p, q) {
                let questionid = this.testdata.paper[p].questionlist[q].id;
                return this.$common.basic.fffind(this.testdata.conreply, 'id', questionid);
            },
            answerstat: function (p, q, v) {
                let answerchoose = this.getanswer(p, q);
                let selected = this.$store.getters.isstu ? answerchoose.selectoption : answerchoose.rightoption;

                let answer = this.$store.getters.isstu ? this.$common.basic.fffind(this.testdata.conanswer, 'id', answerchoose.id).rightoption : answerchoose.rightoption;

                let isright = selected == answer;

                return isright ? selected == v ? 'right' : 'notchoose' : selected == v ? 'error' : answer == v ? 'right' : 'notchoose'

                //return selected == v ? answerchoose.score > 0 ? 'right' : 'error' : 'notchoose';
            },
            answeranalysis: function (p, q) {
                return this.getanswer(p, q).conanalysis;
            },
            saveexaminfo: function () {
                if (this.istesting) {//DEMO应该不保存，测试时试用
                    if (this.examinfo.stat == 9) {
                        this.testfinish();
                    }
                    else {
                        if (!this.examinfo.isnotime) {
                            Cookie.set(this.cookiename, this.examinfo, -1);
                        }
                    }

                }
            },
            setopenids(id) {
                let citem = this.$common.basic.fffind(this.coursedata, 'id', id);
                if (citem.pid > 0) {
                    this.openids.push(citem.pid);
                    this.setopenids(citem.pid);
                }
            },


            showside() {
                this.issidefirst = false;
                this.isshowside = !this.isshowside;
            },
            learnsavewait: function (iscomplete = false) {
                this.isneedsave = false;
                this.learnsave(iscomplete);
            },
            learnsave: function (iscomplete = false) {
                if (!this.isneedsave) {
                    window.clearTimeout(this.savetimeout);
                    this.savetimeout = window.setTimeout(() => {
                        this.isneedsave = true;
                        this.learnsavefun(iscomplete);
                    }, 3000);
                }
                else {
                    this.learnsavefun(iscomplete);
                }
            },
            learnsavefun: function (iscomplete = false) {
                if (this.curcontentid > 0) {
                    let iscom = (this.coursecurcontent.courseinfotypekv == 102) ? iscomplete ? 1 : 0 : (this.coursecurcontent.courseinfotypekv == 101) ? 1 : 0;

                    let jsondata = {
                        'postdata': {
                            'act': 'tc_learn_save', 'id': this.coursecurcontent.courseinfotypekv == 666 ? 0 : this.curcontentid, 'data': { 'learnid': this.learnid, 'iscomplete': iscom, 'duration': this.coursecurcontent.courseinfotypekv == 102 ? this.noteinfo.duration || 0 : 0 }
                        }, 'msg': ''
                    };
                    this.$common.post(jsondata, (res) => {
                        this.learnid = res.learnid;
                    });

                    if (iscom) {
                        this.learnprogress(iscom);
                    }
                }
            },
            learnprogress: function (iscomplete = false) {
                switch (this.coursecurcontent.courseinfotypekv) {
                    case 101:
                        this.coursecurcontent.x_perc = 100;
                        break;
                    case 102:
                        var videoperc = iscomplete ? 100 : Math.round(this.coursecurcontent.x_durationlearn * 100 / this.coursecurcontent.duration);
                        if (videoperc >= 100) { videoperc = iscomplete ? 100 : 99; }
                        if (videoperc > this.coursecurcontent.x_perv) {
                            this.coursecurcontent.x_perc = videoperc;
                        }
                        break;
                    case 666:
                        if (iscomplete) {
                            this.coursecurcontent.x_perc = 100;
                        }
                        break;
                }
            },
            initPolyv(callback) {
                let vodPlayerJs = 'https://player.polyv.net/script/player.js';
                if (!window.polyvPlayer) {
                    const myScript = document.createElement('script');
                    myScript.setAttribute('src', vodPlayerJs);
                    myScript.onload = callback;
                    document.body.appendChild(myScript);
                } else {
                    callback();
                }
            },
            loadPolyv() {

                const polyvPlayer = window.polyvPlayer;
                if (this.coursecurcontent.video) {
                    let jsondata = {
                        'postdata': {
                            'api': 'polyv', 'act': 'polyvplay', 'id': this.curcontentid, 'data': { 'vid': this.coursecurcontent.video }
                        }, 'msg': ''
                    };

                    this.$common.post(jsondata, res => {
                        this.PolyvClear();

                        this.$nextTick(() => {
                            this.player = polyvPlayer({
                                'wrap': '#learnvideo',
                                'width': '100%',
                                'height': '100%',
                                'full_page_screen': false,
                                'pictureInPicture': false,
                                'rightMenu': [],
                                'vid': res.infodata.vid,
                                'playsafe': res.infodata.token,
                                'ts': res.infodata.ts,
                                'sign': res.infodata.sign
                            });

                            this.player.on('s2j_onPlayerInitOver', () => {
                                this.isshowmask = false;

                                if (this.videocurtime > 0) {
                                    this.player.j2s_seekVideo(this.videocurtime);
                                    this.videocurtime = 0;
                                }
                                this.PolyvCurrenttime();
                            });

                            this.player.on('s2j_onPlayOver', () => {
                                this.learnsave(true);
                            });
                        });


                    });
                }


            },
            PolyvCurrenttime() {
                if ((this.coursecurcontent.courseinfotypekv == 102) && (window.polyvPlayer)) {
                    if (!this.isshowmask) {
                        this.noteinfo.duration = Math.round(this.player.j2s_getCurrentTime());
                    }
                    else {
                        this.noteinfo.duration = 0;
                    }
                }
                else {
                    this.noteinfo.duration = 0;
                }

            },
            PolyvSeek(v) {
                let isplay = false;
                if ((this.coursecurcontent.courseinfotypekv == 102) && (window.polyvPlayer)) {
                    if (!this.isshowmask) {
                        isplay = true;
                    }
                }

                if (isplay) {
                    this.player.j2s_seekVideo(v);
                }
                else {
                    this.initPolyv(this.loadPolyv);
                }
            },
            PolyvClear() {
                if (this.player) {
                    this.player.destroy();
                }
            },
            notenew() {
                this.noteinfo.id = 0;
                this.noteinfo.content = '';
                this.noteinfo.recorddate = '';
            },
            notesave() {
                let jsondata = {
                    'postdata': {
                        'act': 'tc_learn_notesave', 'id': this.noteinfo.id, 'data': { 'content': this.noteinfo.content, 'duration': Math.round(this.noteinfo.duration), 'topicid': this.noteinfo.topicid }
                    }, 'msg': ''
                };

                this.$common.post(jsondata, res => {
                    let itemindex = this.notelist.findIndex(item => item.id == res.infodata.id);
                    if (itemindex >= 0) {
                        //this.$set(this.notelist, itemindex, res.infodata);
                        this.notelist.splice(itemindex, 1);//排序
                    }
                    let itemcourse = this.$common.basic.fffind(this.coursedata, 'id', res.infodata.topicid);

                    if (this.$common.basic.isobjexist(itemcourse)) {
                        res.infodata.x_topictitle = this.$common.langinfo(itemcourse.title, itemcourse.title_en);
                    }
                    this.notelist.unshift(res.infodata);
                    this.noteclear();
                });
            },
            notedel(id) {
                let jsondata = {
                    'postdata': {
                        'act': 'tc_learn_notedel', 'id': id
                    }, 'msg': ''
                };

                this.$common.post(jsondata, () => {
                    let itemindex = this.notelist.findIndex(item => item.id == id);
                    if (itemindex >= 0) {
                        this.notelist.splice(itemindex, 1);
                    }
                });
            },
            noteclear() {
                this.noteinfo.id = 0;
                this.noteinfo.content = '';
                this.noteinfo.topicid = this.curcontentid;
                this.noteinfo.recorddate = '';
                this.noteinfo.duration = 0;
            },
            noteshow(id) {
                let notecur = this.$common.basic.fffind(this.notelist, 'id', id);
                if (this.$common.basic.isobjexist(notecur)) {
                    this.$refs["myscroll"].scrollTo(
                        {
                            y: "0"
                        },
                        500
                    );
                    if (notecur.topicid == this.curcontentid) {

                        this.noteinfo = this.$common.basic.jsonclone(notecur);
                        this.noteinfo.content = this.$common.basic.streditor2area(this.noteinfo.content);
                        this.PolyvSeek(notecur.duration);
                    }
                    else {
                        this.showdetail(notecur.topicid, id);
                    }
                }

            }
        },
        mounted() {
            this.datainit();

            this.myinterval = window.setInterval(() => {
                this.learnsave();
            }, 1000 * 60);

            this.remaininterval = window.setInterval(() => {
                if (this.istesting) {
                    if (!this.examinfo.isnotime) {
                        this.examinfo.remainseconds = this.examinfo.remainseconds - 1;
                        if (this.examinfo.remainseconds > 0) {
                            this.saveexaminfo();
                        }

                        if (this.examinfo.remainseconds <= 0) {
                            this.testpost();
                        }
                    }

                }
                this.PolyvCurrenttime();
            }, 1000);

            window.addEventListener('beforeunload', this.learnsave);
        },
        beforeDestroy() {
            this.learnsave();
            window.removeEventListener('beforeunload', this.learnsave);
            window.clearInterval(this.myinterval);
            window.clearInterval(this.remaininterval);
            window.clearTimeout(this.savetimeout);
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
        }
    }
</script>
